'use client';

import { useTranslation } from '@/lib/i18n';
import { cn } from '@/lib/utils';

export default function MarketStatus({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={cn('text-xs h-5 leading-5 rounded-sm bg-[#2D2D2D] text-[#B7B9BC] px-1.5', className)}
    >
      {t('Ended')}
    </span>
  );
}
